import { resolvePathOrUrl } from '@asset-metrix/portal-ui';
import { from as envFrom } from 'env-var';

import { devConfig } from './dev';

const GLOBAL_PROPERTY = 'am-config';

interface ExtendedWindow extends Window {
  [GLOBAL_PROPERTY]: typeof devConfig;
}

declare const window: ExtendedWindow;

const env = envFrom(window[GLOBAL_PROPERTY] ?? devConfig);

/** Generic settings */
export const RELEASE_VERSION = env
  .get('RELEASE_VERSION')
  .default('unknown')
  .asString();

/** portal api base url */
export const PORTAL_API_URL = env
  .get('PORTAL_API_URL')
  .required()
  .asUrlString();

/**
 * portal gateway base url.
 * If no override is defined, the current portal-next URL is used.
 */
export const PORTAL_GATEWAY_API_BASE_URL =
  env.get('PORTAL_GATEWAY_API_BASE_URL').asString() || window.location.origin;

/**
 * Base URL for the portal-user-management app. Set `USER_MANAGEMENT_APP_URL` to a
 * root-relative path (e.g. `/user-management/`) on the same host, a full URL, or
 * leave empty for `/user-management/` on the current origin.
 */
export const USER_MANAGEMENT_APP_URL = resolvePathOrUrl(
  env.get('USER_MANAGEMENT_APP_URL').default('').asString(),
  '/user-management/'
);

/**
 * Base URL for the portal-configurator app. Set `POCO_APP_URL` to a
 * root-relative path (e.g. `/poco/`) on the same host, a full URL, or
 * leave empty for `/poco/` on the current origin.
 */
export const POCO_APP_URL = resolvePathOrUrl(
  env.get('POCO_APP_URL').default('').asString(),
  '/poco/'
);

export const SENTRY_ENABLED = env
  .get('SENTRY_ENABLED')
  .default('false')
  .asBool();

export const SENTRY_DSN = env.get('SENTRY_DSN').asString();
export const SENTRY_MASK_ALL_TEXT = env
  .get('SENTRY_MASK_ALL_TEXT')
  .default('true')
  .asBool();

export const SENTRY_ENVIRONMENT = env
  .get('SENTRY_ENVIRONMENT')
  .default('')
  .asString();

export const NODE_ENV = env.get('NODE_ENV').default('development').asString();

export const ROUTE_BASE_NAME = env
  .get('ROUTE_BASE_NAME')
  .default('')
  .asString();

/** Ag-grid license key */
export const AG_GRID_LICENSE_KEY = env
  .get('AG_GRID_LICENSE_KEY')
  .default('')
  .asString();

/** Download settings */
export const DOWNLOAD_DATE_PREFIX_FORMAT = env
  .get('DOWNLOAD_DATE_PREFIX_FORMAT')
  .default('YYYY-MM-DD HH-mm-ss')
  .asString();

/** Application UUID - used to seed UUIDv5 generator for application-specific UUIDs */
export const APPLICATION_UUID = env
  .get('APPLICATION_UUID')
  .default('2912e629-aa2e-4ee6-bf69-0d00cce41222')
  .asString();
